

// student resource - uses translation keys that are resolved by `t()` in the component
const getStudentsResourceMenuOption = (t) => [
    {
        label: t("footer.getApplication"),
        path: "/registration-application",
    },
    {
        label: t("footer.listOfSchool"),
        path: "/registration-school-details"
    },
    {
        label: t("footer.instructions"),
        path: "/instructions"
    },
    {
        label: t("footer.eSambandhanPortal"),
        path: "http://edu-online.bihar.gov.in/RtiReg/index.Html",
        target: "_blank"
    }
]


// notification
const getNotificationMenuOptions = (t) => [
    {
        label: t("navbar.admissionGuideline_2026_27"),
        path: "https://prod-1.static.codebuckets.in/file/codebucket-production-public/doe-gyandeep/RTE%20%202026-27%20Admission%20Guideline.pdf",
        target: "_blank"
    },
    {
        label: t("footer.generalNotifications"),
        path: "/general-notifications"
    },
    {
        label: t("footer.randomizationNotifications"),
        path: "/randomization-notifications"
    }
]




// login
const getLoginMenuOptions = (t) => [
    {
        label: t("studentLogin.title"),
        path: "/"
    },
    {
        label: t("navbar.School"),
        path: "/school-login"
    },
    {
        label: t("navbar.Department"),
        path: "/department-login"
    }
]




export { getStudentsResourceMenuOption, getNotificationMenuOptions, getLoginMenuOptions };